import React from 'react'
import toast, { Toaster as HotToaster, ToasterProps, ToastOptions } from 'react-hot-toast'
import { InformationCircleIcon } from '@heroicons/react/24/solid'

type Message = string | React.ReactElement

// react-hot-toast ships its types built against an older React; when this file is
// compiled inside a React 19 app the raw Toaster trips TS2786 (return-type variance).
// Casting to the ambient React.FC realigns it to whichever React version compiles
// this file, so it typechecks in both the library (18) and the apps (19).
const Toaster = HotToaster as React.FC<ToasterProps>

// A preconfigured Toaster component with bottom-right positioning and 5000ms default duration.
// Matches the four existing app mounts for drop-in adoption.
export const AppToaster = () => (
  <Toaster position="bottom-right" toastOptions={{ duration: 5000 }} />
)

// notify: thin wrappers over react-hot-toast for consistent success/error/info messages.
export const notify = {
  success: (msg: Message, opts?: ToastOptions) => {
    return toast.success(msg, opts)
  },
  error: (msg: Message, opts?: ToastOptions) => {
    return toast.error(msg, opts)
  },
  info: (msg: Message, opts?: ToastOptions) => {
    return toast(msg, {
      icon: <InformationCircleIcon className="w-5 h-5 text-perfect-shine-600" />,
      ...opts,
    })
  },
}
